import { useState } from "react"
import Modal from "../Modal"
import Button from "../Button"
import api from "../../services/api"

const AssignEncircledAdminModal = ({ isOpen, onClose, onSuccess, user }) => {
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  const handleConfirm = async () => {
    setSaving(true)
    setError(null)

    try {
      await api.adminUpdateUser(user.id, { is_admin: true, is_super_admin: true })
      onSuccess()
      onClose()
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to assign Encircled admin')
    } finally {
      setSaving(false)
    }
  }

  if (!user) return null

  return (
    <Modal isOpen={isOpen} setIsOpen={onClose} width="md:max-w-screen-sm">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-brandSecondary bg-opacity-10 flex items-center justify-center">
            <i className="fa fa-shield-halved text-brandSecondary text-xl"></i>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Assign Encircled Admin</h2>
            <p className="text-sm text-gray-500">{user.name}</p>
          </div>
        </div>

        <div className="mb-6 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <p className="text-sm text-yellow-800">
            <i className="fa fa-triangle-exclamation mr-2"></i>
            This will give <span className="font-semibold">{user.name}</span> full access to all
            organizations, plans, and users across the entire system. This cannot be undone without
            manually removing their admin status.
          </p>
        </div>

        {error && (
          <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-3">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}

        <div className="flex justify-end gap-3">
          <Button type="button" variant="secondary-ghost" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleConfirm}
            disabled={saving}
          >
            {saving ? (
              <>
                <i className="fa fa-spinner fa-spin mr-2"></i>
                Saving...
              </>
            ) : (
              'Confirm'
            )}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default AssignEncircledAdminModal
